import BaseServiceHttp from '../baseService'
class Reservas extends BaseServiceHttp {
  constructor(id) {
    const resource = 'reservas'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Reservas(id)
